import firebase from 'firebase/compat/app';
import 'firebase/compat/auth';
import 'firebase/compat/firestore';
import 'firebase/compat/database';

const firebaseConfig = {
	apiKey            : 'AIzaSyAinwvWGSVt9Rlm1OaZ5vJkl3nPlhmcWEA',
	authDomain        : 'fid-access-replacement-p-94e95.firebaseapp.com',
	databaseURL       : 'https://fid-access-replacement-p-94e95.firebaseio.com',
	projectId         : 'fid-access-replacement-p-94e95',
	storageBucket     : 'fid-access-replacement-p-94e95.appspot.com',
	messagingSenderId : '214186031120',
	appId             : '1:214186031120:web:237334d4e956c054'
};

if ( !firebase.apps.length ) {
	firebase.initializeApp( firebaseConfig );
}

export default firebase;
